export default __webpack_public_path__ + "static/media/bmw.0a42db8f.webp";